import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import { Title } from '@xsolla/ui-core';
import { AlertDangerColorful } from '@xsolla/ui-icons';
import { ModalAlert } from '@xsolla/ui-modal';

import { disconnectMailchimp } from '../../../../api';
import { useNotifications } from '../../../../hooks/useNotifications';
import { FormFooter } from '../../../ui';

type Props = {
  projectId: string;
  onClose: () => void;
  onSubmit: () => void;
};

const DisconnectModal = ({ onClose, onSubmit, projectId }: Props): JSX.Element => {
  const intl = useIntl();
  const { showErrorNotify } = useNotifications();

  const [fetching, setFetching] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const onDisconnectClick = () => {
    setFetching(true);
    setError(false);

    disconnectMailchimp(projectId)
      .then(() => onSubmit())
      .catch((err) => {
        setError(true);
        showErrorNotify(err);
      })
      .finally(() => setFetching(false));
  };

  return (
    <ModalAlert
      footer={
        // eslint-disable-next-line react/jsx-wrap-multilines
        <FormFooter
          isModal
          onSubmit={onDisconnectClick}
          onCancel={onClose}
          fetching={fetching}
          error={error}
          submitButtonPalette="danger"
          submitText={intl.formatMessage({
            id: 'users.mailchimp.button-dropdown.export-completed.button'
          })}
        />
      }>
      <AlertDangerColorful size={40} />
      <Title center indent="sm">
        {intl.formatMessage({ id: 'users.mailchimp.disconnect.title' })}
      </Title>
      <p>{intl.formatMessage({ id: 'users.mailchimp.disconnect.description' })}</p>
    </ModalAlert>
  );
};

export default DisconnectModal;
